import { useId } from 'react';

export function useSvgId(scope: string): string {
  const raw = useId();
  return `vq-${scope}-${raw.replace(/:/g, '')}`;
}
